import React from 'react';
import { Select, Switch, Radio } from '../Layout';
import { TextField, Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid';
import timezones from '../../helpers/consts/timezones';
import i18n from '../../helpers/i18n';
import { TitleH3, TitleSpan, gridItemStyle, checkboxStyle, standardSelectStyle } from '../CreateDeviceContent/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import InfoTooltip from '../InfoTooltip';

export default function DeviceSection({ formik, cnpjs, deviceTypes, isLoadingLocationsAndCnpjs, variant, deviceArchived, duplicateNameError, onNameChange, permissions, repaList = [], isLoadingRepaList = false }) {

    const handleNameChange = (event) => {
        const newName = event.target.value;
        formik.setFieldValue('name', newName);
        // Limpa o erro de nome duplicado quando o usuário começa a digitar
        if (onNameChange) {
            onNameChange();
        }
    };

    return (
        <Grid style={gridItemStyle} item xs={12} md={6} formik={formik}>
            <TitleH3>
                {i18n.t('pages.editDevice.activateDevice')} 
                <TitleSpan>{i18n.t('pages.newDevice.mandatory')}</TitleSpan>
            </TitleH3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}/>
                {variant === 'edit' && (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        padding: '12px 16px',
                        fontSize: '14px',
                        backgroundColor: '#F4F4F6',
                        borderRadius: '4px',
                        fontFamily: 'Open Sans',
                        color: 'var(--ahg-waterloo-darken1)'
                    }}>
                        <Radio
                            values={[
                                { value: true, title: <><strong>{i18n.t('pages.editDevice.activate')}</strong> {i18n.t('pages.editDevice.device')}</> },
                                { value: false, title: <><strong>{i18n.t('pages.editDevice.deactivate')}</strong> {i18n.t('pages.editDevice.device')}</> }
                            ]}
                            value={formik.values.active}
                            onChange={(event) => formik.setFieldValue('active', event.target.value === 'true')}
                            disabled={deviceArchived}
                            name="device-active-status"
                            sx={{ 
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                gap: '40px',
                                width: '100%',
                                '& .MuiFormControlLabel-label': {
                                    fontFamily: 'Open Sans',
                                    fontSize: '14px'
                                }
                            }}
                        />
                    </div>

                )}
                <Tooltip title={variant === 'edit' && !!formik.values?.deviceType ? i18n.t('pages.editDevice.disabledChangeDevice') : ""} arrow>
                    <div style={standardSelectStyle}>
                        <Select
                            items={deviceTypes}
                            id="deviceType"
                            title={i18n.t('pages.newDevice.deviceType')}
                            value={formik.values.deviceType}
                            onChange={(event) => formik.setFieldValue('deviceType', event.target.value)}
                            onBlur={formik.handleBlur}
                            error={formik.touched.deviceType && Boolean(formik.errors.deviceType)}
                            disabled={(variant === 'edit' && !!formik.values?.deviceType) || deviceArchived}
                        />
                    </div>
                </Tooltip>
                {permissions?.dispositivo_repa && (
                    <Tooltip title={variant === 'edit' ? i18n.t('pages.editDevice.disabledRepAEdit') : ""} arrow>
                        <div style={checkboxStyle}>
                            <Switch
                                label={i18n.t('pages.newDevice.activateRepA')}
                                checked={formik.values.enableRepA || false}
                                onChange={(event) => {
                                    const isChecked = event.target.checked;
                                    formik.setFieldValue('enableRepA', isChecked);
                                    // Map enableRepA to is_repa for the backend
                                    formik.setFieldValue('is_repa', isChecked);
                                }}
                                disabled={variant === 'edit' || deviceArchived}
                            />
                            <InfoTooltip tooltip={i18n.t('pages.newDevice.activateRepADescription')} />
                        </div>
                    </Tooltip>
                )}
                <div style={standardSelectStyle}>
                    <Select
                        items={cnpjs}
                        id="cnpj"
                        title={i18n.t('pages.newDevice.cnpj')}
                        value={formik.values.cnpj}
                        disabled={isLoadingLocationsAndCnpjs || deviceArchived}
                        onChange={(event) => formik.setFieldValue('cnpj', event.target.value)}
                        onBlur={formik.handleBlur}
                        error={formik.touched.cnpj && Boolean(formik.errors.cnpj)}
                    />
                <TextField
                    id="name"
                    label={i18n.t('pages.newDevice.deviceName')}
                    value={formik.values.name}
                    onChange={handleNameChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                    disabled={deviceArchived}
                    sx={{
                        width: '100%',
                        '& .MuiInputBase-input': {
                            fontSize: '14px',
                            fontFamily: 'Open Sans',
                            color: 'var(--ahg-waterloo-darken1)'
                        },
                        '& .MuiInputLabel-root': {
                            fontSize: '14px',
                            fontFamily: 'Open Sans',
                            color: 'var(--ahg-waterloo-darken1)'
                        },
                        '& .MuiFormHelperText-root': {
                            fontSize: '12px',
                            fontFamily: 'Open Sans',
                            color: 'var(--ahg-waterloo-darken1)'
                        }
                    }}
                />
                <Select
                    items={timezones}
                    id="timezone"
                    title={i18n.t('pages.newDevice.timezone')}
                    value={formik.values.timezone}
                    onChange={(event) => formik.setFieldValue('timezone', event.target.value)}
                    onBlur={formik.handleBlur}
                    error={formik.touched.timezone && Boolean(formik.errors.timezone)}
                    enableSearch={true}
                    disabled={deviceArchived}
                />
                <div style={checkboxStyle}>
                    <Switch
                        label={i18n.t('pages.newDevice.expirationDate')}
                        checked={formik.values.expirationDate}
                        onChange={(event) => formik.setFieldValue('expirationDate', event.target.checked)}
                        disabled={deviceArchived}
                    />
                    <InfoTooltip tooltip={i18n.t('pages.newDevice.expirationDateDescription')} />
                </div>
                {formik.values.expirationDate && (
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '8px', justifyContent: 'start' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                disabled={deviceArchived}
                                format="DD/MM/YYYY"
                                sx={{
                                    marginTop: '16px !important',
                                    marginLeft: '16px !important',
                                    width: 'calc(100% - 32px)',
                                    fontSize: 12,
                                    '& .MuiInputBase-root': {
                                        flexDirection: 'row-reverse',
                                    },
                                    '& .MuiButtonBase-root': {
                                        color: '#2D9CDB',
                                    },
                                }}
                                slotProps={{ textField: { placeholder: i18n.t('filter.from') } }}
                                value={formik.values.startPeriod}
                                onChange={(val) => formik.setFieldValue('startPeriod', val)}

                            />

                            <DatePicker
                                disabled={deviceArchived}
                                format="DD/MM/YYYY"
                                sx={{
                                    marginTop: '16px !important',
                                    marginLeft: '16px !important',
                                    width: 'calc(100% - 32px)',
                                    fontSize: 12,
                                    '& .MuiInputBase-root': {
                                        flexDirection: 'row-reverse',
                                    },
                                    '& .MuiButtonBase-root': {
                                        color: '#2D9CDB',
                                    },
                                }}
                                slotProps={{ textField: { placeholder: i18n.t('filter.to') } }}
                                value={formik.values.endPeriod}
                                onChange={(val) => formik.setFieldValue('endPeriod', val)}
                            />
                        </LocalizationProvider>
                    </div>
                )}
            </div>
        </Grid>
    )
}